// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';

import {alertService} from '../../../services/AlertService';

import TableCard from "../../../components/tablecard/TableCard";
import ModalForm from "../../../components/modal/form/ModalForm";

import {getLokasiTugas, insertLokasiTugas, lokasiTugasSelector, updateLokasiTugas} from './lokasiTugasSlice';

import {Colors} from "../../../assets/Colors";
import {maxPageGlobal} from "../../../assets/config";

const LokasiTugasPage = ({}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [firstLoading, setFirstLoading] = useState(false);
    const [start, setStart] = useState(0);
    const [count, setCount] = useState(maxPageGlobal);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(0);
    const [search, setSearch] = useState('');
    const [searchFetch, setSearchFetch] = useState(false);
    const [insertFetch, setInsertFetch] = useState(false);
    const [updateFetch, setUpdateFetch] = useState(false);
    const [showModalAdd, setShowModalAdd] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [currentData, setCurrentData] = useState({});

    const lokasiTugas = useSelector(
        lokasiTugasSelector
    );

    useEffect(() => {
        dispatch(getLokasiTugas({
            start: start,
            count: count,
            search: '',
        }));
    }, []);

    useEffect(() => {

        if ((search !== '') && lokasiTugas.isGetSuccess && !lokasiTugas.isGetFetching) {
            let calc = lokasiTugas?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = lokasiTugas.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        } else if ((search === '') && lokasiTugas.isGetSuccess && !lokasiTugas.isGetFetching) {
            let calc = lokasiTugas?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = lokasiTugas.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        }

        if (!lokasiTugas?.isGetFetching && lokasiTugas.isGetSuccess && (maxPage === 0) && (firstLoading === false)) {
            let calc = lokasiTugas?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = lokasiTugas.data ? Math.ceil(calc / count) : 1;
            setMaxPage(tempMaxPage);
            setFirstLoading(true);
            dispatch(getLokasiTugas({
                start: start,
                count: count,
                search: search,
            }));
        }

        if (
            (insertFetch)
        ) {
            setInsertFetch(false);
            if (lokasiTugas.isGetSuccess) {
                alertService.success(lokasiTugas.message, {autoClose: true, keepAfterRouteChange: false});
                dispatch(getLokasiTugas({
                    start: start,
                    count: count,
                    search: search,
                }));
            }
        }

        if (
            (updateFetch)
        ) {
            setUpdateFetch(false);
            if (lokasiTugas.isUpdateSuccess) {
                alertService.success(lokasiTugas.message, {autoClose: true, keepAfterRouteChange: false});
                dispatch(updateLokasiTugas({
                    start: start,
                    count: count,
                    search: search,
                }));
            }
        }

    });

    // function handleGetLokasiTugas(params) {
    //   return dispatch(getLokasiTugas(params));
    // }

    function handleInsertLokasiTugas(param) {
        setInsertFetch(true);
        const params = {
            namaLokasiTugas: param.inputOneValue,
            lokasiTugasID: param.dropdownOneValue,
        };
        dispatch(insertLokasiTugas(params));
    }

    function handleUpdateLokasiTugas(param) {
        setUpdateFetch(true);

        const params = {
            namaLokasiTugas: param.inputOneValue,
            idLokasiTugas: currentData.LokasiTugasID,
            status: param.status,
        };
        dispatch(updateLokasiTugas(params));
    }

    function handleSearch(searchValue) {
        let params = {
            start: 0,
            count: 5,
            search: searchValue,
        }
        dispatch(getLokasiTugas(params));

        setStart(0);
        setCount(5);
        setSearch(searchValue);
        setSearchFetch(true);
    }

    function handleUpdatePage(newPage) {
        let newStart = (newPage * count) - count;

        let params = {
            start: newStart,
            count: count,
            search: search,
        }
        dispatch(getLokasiTugas(params));

        setPage(newPage)
        setStart(newStart)
    }

    function handleUpdateCount(newCount) {
        let calc = (lokasiTugas.count - 1);
        if (calc === 0) {
            calc = 1;
        }

        let params = {
            start: (newCount === "-1") ? 0 : start,
            count: (newCount === "-1") ? lokasiTugas.count : newCount,
            search: search,
        }
        dispatch(getLokasiTugas(params));

        setPage(1);
        setCount((newCount === "-1") ? lokasiTugas.count : newCount)
        setStart((newCount === "-1") ? 0 : start);
        setMaxPage((newCount === "-1") ? 1 : Math.ceil(calc / newCount))
    }

    function handleCurrentData(values) {
        setCurrentData(values);
    }

    function handleModal(status) {
        setShowModalAdd(status.showModalAdd);
        setShowModalEdit(status.showModalEdit);
    }

    if (!firstLoading) {
        return <div>loading</div>
    } else {
        return (

            <div className="md:ml-64">
                <div style={{background: Colors.primary}} className="pt-14 pb-16 px-3 md:px-8 h-auto">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                    </div>
                </div>

                <div className="px-3 md:px-8 h-auto -mt-32">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 px-4">
                            <TableCard
                                backButton={true}
                                backUrl={"master"}
                                handleSearch={handleSearch}
                                searchPlaceholder="Lokasi Tugas"
                                updatePage={handleUpdatePage}
                                updateCount={handleUpdateCount}
                                currentData={handleCurrentData}
                                currentPage={page}
                                maxPage={maxPage}
                                tableTitle="Master Lokasi Tugas"
                                tableData={lokasiTugas.data}
                                colOneTitle="ID"
                                colOneData="LokasiTugasID"
                                colTwoTitle="Nama Lokasi Tugas"
                                colTwoData="NamaLokasiTugas"
                                status="Status"

                                fetching={lokasiTugas.isGetFetching}
                                modal={handleModal}
                                editEnabled={true}

                            />
                        </div>
                    </div>
                </div>
                {showModalAdd &&
                    <ModalForm
                        showModal={showModalAdd}
                        addEnabled={true}
                        modal={handleModal}
                        modalTitle="Tambah Lokasi Tugas"
                        inputOneTitle="Nama LokasiTugas"
                        inputOnePlaceholder=""
                        submitButtonTitle="Submit"
                        handleSubmit={handleInsertLokasiTugas}
                    />
                }
                {showModalEdit &&
                    <ModalForm
                        showModal={showModalEdit}
                        editEnabled={true}
                        id={currentData.LokasiTugasID}
                        modal={handleModal}
                        modalTitle="Ubah Lokasi Tugas"
                        inputOneTitle="Nama LokasiTugas"
                        inputOneValue={currentData.NamaLokasiTugas}
                        status={currentData.Status}
                        submitButtonTitle="Submit"
                        handleSubmit={handleUpdateLokasiTugas}
                    />
                }
            </div>

        )
    }

}


export default LokasiTugasPage;